import { ResumoCategoriaItem } from "core/features/relatorios/typings";
import { defaultContentMapperXlsx } from "infra/packages/json-as-xlsx/index";
import xlsx, { IColumn, IContent, IJsonSheet, ISettings } from "json-as-xlsx";
import moment from "moment";
import {
  ContasRecorrentesPdfResponse,
  ContaRecorrenteItem,
} from "core/features/conta-recorrente/typings";
import { ContasRecorrentesFields } from "core/features/relatorios/typings";
import { OperacaoEnum } from "core/resources/enums/conta";

export function exportExcelContasRecorrentes({
  data,
  selectedFields,
  mes,
  operacao,
}: {
  data: ContasRecorrentesPdfResponse;
  selectedFields?: ContasRecorrentesFields[];
  mes?: string;
  operacao?: OperacaoEnum;
}) {
  const settings: ISettings = {
    fileName: `${
      operacao === OperacaoEnum.Receita
        ? "Receitas recorrentes"
        : "Despesas recorrentes"
    } - ${moment(mes, "YYYY-MM").format("MM_YYYY")}`,
    extraLength: 3,
    writeOptions: {},
  };

  const columns = getColumns();

  const sheets: IJsonSheet[] = [];

  sheets.push({
    sheet: "Contas",
    columns: columns,
    content: data.items.map(defaultContentMapperXlsx),
  });

  if (selectedFields?.includes("resumoContaCategoria")) {
    const columnsResumo = getColumnsResumo();

    sheets.push({
      sheet: "Resumo por categoria",
      columns: columnsResumo,
      content: data.resumoPorCategoria.map(defaultContentMapperXlsx),
    });
  }

  xlsx(sheets, settings);
}

function getColumns() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Descrição",
    value: (row: IContent) =>
      (row as unknown as ContaRecorrenteItem)?.descricao ?? "",
  });

  columns.push({
    label: "Pessoa",
    value: (row: IContent) =>
      (row as unknown as ContaRecorrenteItem)?.pessoa?.nome ?? "",
  });

  columns.push({
    label: "Valor",
    format: "#,###0.00",
    value: (row: IContent) => (row as unknown as ContaRecorrenteItem)?.valor,
  });

  columns.push({
    label: "Intervalo",
    value: (row: IContent) =>
      (row as unknown as ContaRecorrenteItem)?.tipoIntervaloRepeticao?.nome ??
      "",
  });

  columns.push({
    label: "Dia",
    value: (row: IContent) =>
      (row as unknown as ContaRecorrenteItem)?.diaVencimento ?? "",
  });

  columns.push({
    label: "Gerada",
    value: (row: IContent) =>
      (row as unknown as ContaRecorrenteItem)?.gerada ? "Sim" : "Não",
  });

  return columns;
}

function getColumnsResumo() {
  const columns: IColumn[] = [];

  columns.push({
    label: "Categoria",
    value: (row: IContent) => (row as unknown as ResumoCategoriaItem).nome,
  });

  columns.push({
    label: "Total",
    format: "#,###0.00",
    value: (row: IContent) => (row as unknown as ResumoCategoriaItem).valor,
  });

  return columns;
}
